import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=5d3ad52b&scoped=true"
import script from "./OpenQuestion.vue?vue&type=script&lang=js"
export * from "./OpenQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3ad52b",
  null
  
)

export default component.exports